import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';
import { isDestinationCountry } from 'utils/countries';

/**
 * Region/city required only for destination countries (AssessmentV2 BusinessOwnership).
 * End date not required when current === true.
 */
const businessOwnershipItemSchema = Yup.object({
    annual_sales: validateField(ValidationType.INTEGER_POSITIVE),
    country: validateField(ValidationType.STRING),
    current: validateField(ValidationType.BOOLEAN),
    net_company_value: validateField(ValidationType.INTEGER_POSITIVE),
    net_profit: validateField(ValidationType.INTEGER),
    number_employees: validateField(ValidationType.INTEGER_POSITIVE),
    percent_ownership: validateField(ValidationType.INTEGER_POSITIVE),
    start: validateField(ValidationType.STRING),
    type: validateField(ValidationType.STRING),
    end: Yup.mixed().when('current', {
        is: true,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => validateField(ValidationType.STRING),
    }),
    region: Yup.string()
        .nullable()
        .when('country', {
            is: isDestinationCountry,
            then: (schema) => schema.required('Region is required'),
            otherwise: (schema) => schema.nullable(),
        }),
    city: Yup.string()
        .nullable()
        .when('country', {
            is: isDestinationCountry,
            then: (schema) => schema.required('City is required'),
            otherwise: (schema) => schema.nullable(),
        }),
});

export const businessOwnershipValidationSchema = Yup.object({
    has_business: Yup.boolean().nullable(),
    businesses: Yup.array().when('has_business', {
        is: true,
        then: (schema) => schema.of(businessOwnershipItemSchema).min(1),
        otherwise: () => Yup.array().notRequired(),
    }),
});
